<template>
    <!--
        latestImageIdとunsavedPuriCountはこのheader,footerタイプの組み合わせだと必要ないが
        BaseLayoutの設計上必須propsにしているので、ダミーの値を渡している
    -->
    <base-layout
        :header-type="headerType.LOGOONLY"
        :footer-type="footerType.COPYRIGHTONLY"
        latest-image-id="dummy"
        unsaved-puri-count="0"
    >
        <jhs-free-heading/>
        <section class="l-section">
            <heading-bg title="申し込みできません"/>
            <div class="l-element">
                <p class="m-text-normal is-primary is-text-center is-text-bold is-mgb0">利用規約を確認してね！</p>
            </div>
            <div class="l-element">
                <p class="m-text-normal is-mgb0">
                    お客様は利用規約に違反されため、本サービスへの申し込みを行うことができません。<br/>
                    <br/>
                    詳しくは<link-text :link="this.termsUrl" :new-window="true" text="利用規約" data-jest="terms-link" />の「禁止行為」をご確認ください。
                </p>
            </div>
        </section>
        <div class="l-element">
            <btn @click="onClickTopButton" text="ピクトリンクTOPへ" :priority="cssPriority.SECONDARY" data-jest="top-link"/>
        </div>
    </base-layout>
</template>

<script>
import BaseLayout from "../../templates/BaseLayout.vue";
import JhsFreeHeading from "../../molecules/JhsFreeHeading.vue";
import HeadingBg from "../../atoms/HeadingBg.vue";
import Btn from "../../atoms/Btn.vue"
import LinkText from "../../atoms/LinkText.vue";
import * as metaInformationUtil from "../../../util/metaInformationUtil.js";
import * as urlUtil from "../../../util/UrlUtil.js";
import {cssPriority} from "../../../view-model/enum/CSSPriority";
import {headerType} from "../../../view-model/enum/HeaderType";
import {footerType} from "../../../view-model/enum/FooterType";
import {mapGetters} from "vuex";
import {moveToTopPage} from "./common/jhsFreeLinkUtils";

export default {
    name: "JhsFreeErrorEntryPenalty",
    components: {BaseLayout, JhsFreeHeading, HeadingBg, Btn, LinkText},
    props: {
        /**
         * titleタグ
         */
        title: {
            type: String,
            required: true
        },
        /**
         * meta description
         */
        description: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            headerType: headerType,
            footerType: footerType,
            cssPriority: cssPriority,
            termsUrl: urlUtil.policyUrlUtil.termsOfServiceUrl(),
        }
    },
    computed: {
        ...mapGetters('AccountStoreV2', [
            'isAppli'
        ]),
    },
    methods: {
        setTitleAndDesc() {
            metaInformationUtil.setTitleAndDescription(this.title, this.description)
        },
        onClickTopButton(){
            moveToTopPage(this.isAppli,'ピクトリンクTOPへ')
        }
    },
    mounted() {
        this.setTitleAndDesc()
    }
}
</script>
